import {commonConfig} from "../../common/js/config";
import {formatBigNumber, formatNumberString} from "../../common/js/utils";
import {formatStorageMb} from "../../common/js/creem-billing-dom";
import i18next from "i18next";

const monthlyBillingPeriod = 'every-month';
const annualBillingPeriod = 'every-year';
let selectedBillingPeriod = annualBillingPeriod;
let selectedCountry = '';

export function scrollToHashTarget() {
    const hash = window.location.hash;
    if (!hash || !hash.startsWith('#')) {
        return;
    }

    const target = document.getElementById(hash.slice(1));
    if (!target) {
        return;
    }

    const header = document.querySelector('.app-header');
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'auto',
    });
    $('.app-header').css('top', '0');
}

const subscriptionBillingPeriod = (subscription) => (
    subscription?.billing_period
    || (String(subscription?.product_code || '').endsWith('_ANNUAL')
        ? annualBillingPeriod
        : monthlyBillingPeriod)
);

export function setLandingBillingPeriod(period) {
    if (![monthlyBillingPeriod, annualBillingPeriod].includes(period)) {
        return;
    }
    selectedBillingPeriod = period;
    if (selectedCountry) {
        updateSubscriptions(selectedCountry);
    }
}

function renderIncludeItem(text, tooltipText = "") {
    const tooltipIcon = tooltipText ? `<div class="package-quantity-tooltip-icon" tabindex="0" data-bs-toggle="tooltip" data-bs-placement="right" title="${tooltipText}">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 24 24" style="width: 17px" xml:space="preserve"><g><path fill="currentColor" fill-rule="evenodd" d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25zM2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0zm7.875 2.282v.149h2.067v-.149c.004-.404.056-.743.155-1.018.104-.278.26-.52.472-.726.215-.206.49-.405.825-.595.381-.21.71-.448.987-.715a2.82 2.82 0 0 0 .64-.915c.153-.344.229-.732.229-1.167 0-.645-.17-1.201-.509-1.67-.335-.473-.805-.837-1.409-1.093-.6-.255-1.295-.383-2.085-.383-.724 0-1.386.122-1.986.366a3.33 3.33 0 0 0-1.44 1.098c-.36.488-.55 1.095-.571 1.82h2.21c.02-.36.115-.655.285-.887.174-.237.391-.412.652-.527.264-.118.544-.177.838-.177.318 0 .606.061.862.183.26.122.468.294.62.515s.23.482.23.783c0 .267-.057.51-.173.727a2.092 2.092 0 0 1-.478.583c-.199.172-.424.33-.677.475-.368.21-.68.44-.937.692-.256.248-.455.576-.596.984-.136.408-.207.957-.21 1.647zm.118 3.352c.27.244.59.366.962.366a1.375 1.375 0 0 0 1.173-.623c.128-.191.193-.403.193-.635a1.14 1.14 0 0 0-.41-.881 1.375 1.375 0 0 0-.956-.366c-.372 0-.693.122-.962.366a1.148 1.148 0 0 0-.403.88c0 .352.134.649.403.893z" clip-rule="evenodd" opacity="1" data-original="#000000"/></g></svg>
  </div>` : "";

    return `<div class="package-quantity">
  <div class="package-quantity-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd" d="m20.586 5-1.271 1.296L8 17.836l-3.315-3.38-1.271-1.297H2v1.443l1.271 1.296L7.293 20h1.414L20.73 7.738 22 6.442V5z"></path>
    </svg>
  </div>
 <div class="d-flex align-items-center">
  <div class="package-quantity-text">${text}</div>
  ${tooltipIcon}
 </div>
  
</div>`;
}

function updatePromoBanner(discount) {
    const promoBanner = $('[data-subscription-promo]');
    if (!promoBanner.length) {
        return;
    }

    if (discount && Number(discount.percent) > 0) {
        promoBanner.removeClass('is-hidden');
        promoBanner.find('[data-promo-percent]').text(`-${discount.percent}%`);
        promoBanner.find('[data-promo-title]').text(discount.name || '');
        promoBanner.find('[data-promo-description]').text(discount.description || '');
    } else {
        promoBanner.addClass('is-hidden');
        promoBanner.find('[data-promo-percent]').text('');
        promoBanner.find('[data-promo-title]').text('');
        promoBanner.find('[data-promo-description]').text('');
    }
}

export function setRadioAndUpdateSubscriptions(country) {
    $(`input[type="radio"][value=${country}]`).prop("checked", true);
    updateSubscriptions(country);
}

export function updateSubscriptions(country) {
    if (!window.subscriptionsData) {
        return;
    }

    const countryData = window.subscriptionsData[country];
    const grid = $('.subscription-grid');
    const unavailable = $('[data-subscription-unavailable]');
    const periodToggle = $('[data-landing-billing-period-toggle]');
    selectedCountry = country;
    if (!countryData) {
        updatePromoBanner(null);
        periodToggle.addClass('is-hidden');
        grid.addClass('is-hidden');
        unavailable
            .text(i18next.t(
                'pricing:dom.landingCatalogUnavailable',
                'Plans are not available for this country yet.',
            ))
            .removeClass('is-hidden');
        return;
    }
    grid.removeClass('is-hidden');
    unavailable.text('').addClass('is-hidden');

    const currencyLocal = commonConfig.currencies[countryData.currency] || countryData.currency;
    const discount = countryData.discount;
    const discountPercent = discount ? Number(discount.percent) : 0;
    const isCatalog = window.landingPricingSource === 'catalog';
    updatePromoBanner(discount);

    const subscriptions = countryData.subscriptions || [];
    const availablePeriods = new Set(subscriptions.map(subscriptionBillingPeriod));
    let activeBillingPeriod = isCatalog
        ? selectedBillingPeriod
        : monthlyBillingPeriod;
    if (!availablePeriods.has(activeBillingPeriod)) {
        activeBillingPeriod = availablePeriods.has(annualBillingPeriod)
            ? annualBillingPeriod
            : monthlyBillingPeriod;
    }
    if (isCatalog && availablePeriods.size > 1) {
        periodToggle.removeClass('is-hidden');
        periodToggle.find('[data-billing-period="every-year"]')
            .text(i18next.t('pricing:dom.billingAnnual', 'Annual'));
        periodToggle.find('[data-billing-period="every-month"]')
            .text(i18next.t('pricing:dom.billingMonthly', 'Monthly'));
        periodToggle.find('[data-billing-period]').each(function () {
            $(this).attr(
                'aria-pressed',
                $(this).attr('data-billing-period') === activeBillingPeriod ? 'true' : 'false',
            );
        });
    } else {
        periodToggle.addClass('is-hidden');
    }

    const subscriptionsByType = {};
    subscriptions
        .filter((subscription) => (
            subscriptionBillingPeriod(subscription) === activeBillingPeriod
        ))
        .forEach((subscription) => {
            subscriptionsByType[subscription.type] = subscription;
        });

    $('.subscription-card').each(function () {
        const card = $(this);
        const planType = card.data('plan');
        const subscription = subscriptionsByType[planType];

        if (!subscription) {
            card.addClass('is-hidden');
            return;
        }

        card.removeClass('is-hidden');

        const planTypeUpper = String(subscription.type || planType || '').toUpperCase();
        const planTitleByType = {
            STARTER: i18next.t('pricing:dom.subscribePackageNameStarter', 'Starter'),
            BASE: i18next.t('pricing:dom.subscribePackageNameBase', 'Base'),
            PRO: i18next.t('pricing:dom.subscribePackageNamePro', 'Pro'),
        };
        const title = planTitleByType[planTypeUpper] || subscription.name || subscription.display_name || subscription.type;
        const descriptionEl = card.find('[data-description]');
        const annual = isCatalog && subscriptionBillingPeriod(subscription) === annualBillingPeriod;
        const basePrice = Number(
            annual
                ? (subscription.monthly_equivalent_amount || (Number(subscription.price) / 12))
                : subscription.price,
        );
        const discountedPrice = Number(
            annual
                ? (
                    subscription.effective_monthly_equivalent_amount
                    || (Number(subscription.discounted_price || subscription.price) / 12)
                )
                : (subscription.discounted_price || subscription.price),
        );
        const hasDiscount = discountPercent > 0 && discountedPrice < basePrice;

        const titleEl = card.find('[data-plan-title]');
        if (titleEl.length) {
            titleEl.text(title);
        } else {
            card.find('.subscription-title').text(title);
        }


        if (!isCatalog && subscription.description) {
            descriptionEl.text(subscription.description).removeClass('is-hidden');
        } else {
            descriptionEl.text('').addClass('is-hidden');
        }

        //descriptionEl.text('').addClass('is-hidden');

        const displayedCardPrice = hasDiscount
            ? Math.floor(discountedPrice)
            : discountedPrice;

        card.find('[data-price-new]').text(
            `${formatNumberString(displayedCardPrice)} ${currencyLocal}`
        );

        const oldPriceEl = card.find('[data-price-old]');
        const discountBadge = card.find('[data-discount-badge]');
        if (hasDiscount) {
            oldPriceEl.text(`${formatNumberString(basePrice)} ${currencyLocal}`).removeClass('is-hidden');
            discountBadge.text(`-${discountPercent}%`).removeClass('is-hidden');
        } else {
            oldPriceEl.text('').addClass('is-hidden');
            discountBadge.text('').addClass('is-hidden');
        }

        card.find('[data-annual-charge], [data-annual-savings], [data-landing-tax-note]').remove();
        if (annual) {
            $('<div>', {
                class: 'subscription-annual-charge',
                'data-annual-charge': '',
                text: i18next.t('pricing:dom.billedAnnually', {
                    amount: `${formatNumberString(subscription.discounted_price || subscription.price)} ${currencyLocal}`,
                    defaultValue: `Billed ${formatNumberString(subscription.discounted_price || subscription.price)} ${currencyLocal} annually`,
                }),
            }).insertAfter(card.find('.subscription-price'));
            $('<div>', {
                class: 'subscription-annual-savings',
                'data-annual-savings': '',
                text: i18next.t('pricing:dom.twoMonthsFree', '2 months free'),
            }).insertAfter(card.find('[data-annual-charge]'));
        }
        if (isCatalog) {
            $('<div>', {
                class: 'subscription-tax-note',
                'data-landing-tax-note': '',
                text: i18next.t('pricing:dom.landingTaxesAtCheckout', 'Taxes calculated at checkout.'),
            }).insertAfter(
                card.find('[data-annual-savings]').length
                    ? card.find('[data-annual-savings]')
                    : card.find('.subscription-price'),
            );
        }

        const productCode = subscription.product_code;
        if (isCatalog && productCode) {
            const link = card.find('a').first();
            const baseHref = String(link.attr('href') || '').split('?')[0];
            link.attr('href', `${baseHref}?plan=${encodeURIComponent(productCode)}`);
        }

        const includeList = card.find('[data-include-list]');
        includeList.empty();

        const includeTitle = i18next.t('pricing:dom.packageIncludeTitle', 'Included');
        includeList.append(`<div class="package-include-title">${includeTitle}:</div>`);

        const tooltipConnections = includeList.data('tooltip-connections') || '';
        const tooltipTokens = includeList.data('tooltip-tokens') || '';

        const connectionQuantity = Number(subscription.connection_quantity) || 0;
        const tokenQuantity = Number(subscription.token_quantity) || 0;
        const accountQuantity = Number(subscription.account_quantity) || 0;

        if (connectionQuantity) {
            const connectionsQuantityFormatted = formatBigNumber(connectionQuantity);
            const connectionsText = i18next.t('pricing:dom.landingConnectionsShort', {
                quantity: connectionsQuantityFormatted,
                defaultValue: `Connections ${connectionsQuantityFormatted}`,
            });
            includeList.append(
                renderIncludeItem(connectionsText, tooltipConnections)
            );
        }
        if (tokenQuantity) {
            const tokensQuantityFormatted = formatBigNumber(tokenQuantity);
            const tokensText = i18next.t('pricing:dom.landingTokensShort', {
                quantity: tokensQuantityFormatted,
                defaultValue: `Tokens ${tokensQuantityFormatted}`,
            });
            includeList.append(
                renderIncludeItem(tokensText, tooltipTokens)
            );
        }
        if (accountQuantity) {
            const accountsText = i18next.t('pricing:dom.landingOlxAccountsShort', {
                quantity: accountQuantity,
                defaultValue: `OLX accounts ${accountQuantity}`,
            });
            includeList.append(
                renderIncludeItem(accountsText)
            );
        }

        if (isCatalog) {
            const delayedOperations = Number(subscription.delayed_operations_limit) || 0;
            const imageFiles = Number(subscription.image_asset_file_limit) || 0;
            const imageStorage = Number(subscription.image_asset_storage_mb) || 0;

            if (delayedOperations) {
                includeList.append(renderIncludeItem(
                    i18next.t('pricing:dom.landingScheduledActions', {
                        quantity: formatBigNumber(delayedOperations),
                        defaultValue: `Scheduled actions ${formatBigNumber(delayedOperations)}`,
                    }),
                    i18next.t(
                        'pricing:dom.landingScheduledActionsTooltip',
                        'Maximum scheduled actions available at the same time.',
                    ),
                ));
            }
            if (imageFiles) {
                includeList.append(renderIncludeItem(
                    i18next.t('pricing:dom.landingImageFiles', {
                        quantity: formatBigNumber(imageFiles),
                        defaultValue: `Image files ${formatBigNumber(imageFiles)}`,
                    }),
                    i18next.t(
                        'pricing:dom.landingImageFilesTooltip',
                        'Maximum images stored in the image library.',
                    ),
                ));
            }
            if (imageStorage) {
                includeList.append(renderIncludeItem(
                    i18next.t('pricing:dom.landingImageStorage', {
                        quantity: formatStorageMb(imageStorage),
                        defaultValue: `Image storage ${formatStorageMb(imageStorage)}`,
                    }),
                    i18next.t(
                        'pricing:dom.landingImageStorageTooltip',
                        'Total storage available for image files.',
                    ),
                ));
            }
        }

        (subscription.features || []).forEach((feature) => {
            includeList.append(renderIncludeItem(feature.title, feature.description || ""));
        });
    });
}
